import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const internetConnectionSelector = (state: RootState): boolean => state.internetConnection;
